<template>
  <div class="sm-regist-inner code">
    <form 
      class="sm-regist__code"
      @submit.prevent="handleSubmit"
    >
      <h3 class="sm-txt-center">Please enter the activation code to start the registration</h3>
      <input-text
        v-model="code"
        v-validate="'required|alpha_num'"
        name="code"
        data-vv-as="Activation code"
        :error="errors.first('code')"
      />
      <btn-block
        :type="'submit'"
        :text="'Register'"
        :class="'sm-btn--medium'"
      />
    </form>
  </div>
</template>

<script>
import InputText from '@/components/InputText';

export default {
  name: 'registartion-code',
  components: {
    'input-text': InputText
  },
  props: {
    codeError: {}
  },
  data() {
    return {
      code: ''
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validate()
        .then(valid => {
          if (!valid)
            return;

          this.$emit('submit', this.code);
        })
    }
  },
  watch: {
    codeError(val) {
      if (val)
        this.errors.add({
          field: 'code',
          msg: val
        })
    }
  }
}
</script>